export default {
  email: {
    format: 'email',
    required: true
  }
};

